import { availableSortOrders } from '@domain-group/fe-allhomes-search-api';
export var defaultSortOption = 'lowest-price';
export var sortOptions = searchOptions => availableSortOrders(searchOptions).map(_ref => {
  var urlSlug = _ref.urlSlug,
    label = _ref.label;
  return {
    value: urlSlug,
    label
  };
});